import { styled } from "styled-components";

export const Button = styled.div`
  display: flex;
  width: 67px;
  height: 27px;
  align-items: center;
  justify-content: center;
  background-color: var(--lightGray);
  border: 2px solid var(--black);
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
`;
